// Re-check the signed-in user's own password before a sensitive admin action
// (assigning/removing a teacher or substitute, editing a department admin).
// These screens used to call /api/auth/login for this, but every login now
// takes a slot in the device limit and can sign one of the user's real
// devices out — /api/auth/verify-password only checks the password.

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/** @returns {Promise<Response>}  `.ok` is true when the password matches. */
export function verifyMyPassword(password) {
  const token = localStorage.getItem('desky_token');
  return fetch(`${API_URL}/api/auth/verify-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ password }),
  });
}
